import { useReactiveVar } from "@apollo/client";
import { isEmbedVar, isMiniAppVar } from "../vars";
export const useEmbedMode = () => {
    const isEmbed = useReactiveVar(isEmbedVar);
    const isMiniApp = useReactiveVar(isMiniAppVar);
    return {
        isEmbedMode: isEmbed || isMiniApp,
        isEmbed,
        isMiniApp,
    };
};
